import Icon from "@Components/generic/icon";
import { faFire } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { Stack, Typography, useTheme } from "@mui/material";

import { useTrainingPlansProgressContext } from "@/context/game/training-plans/training-plans-progress-context";
import { PeriodCompleteMessageBox, ProgressBarSegment, StreakBanner } from "@Components/training-plans/training-plans-drawer/training-plans-drawer.styled";

const TrainingPlansDrawerProgress = () => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const { trainingPlanModel } = useTrainingPlansProgressContext();
  const streakColor = theme.palette.dsAmber?.v100 ?? theme.palette.dsOrange?.v200 ?? theme.palette.dsPrimary.v300;

  if (!trainingPlanModel) {
    return null;
  }

  return (
    <>
      {trainingPlanModel.showStreak && (
        <StreakBanner>
          <Stack alignItems="center" direction="row" spacing={0.75}>
            <Icon icon={faFire} color={streakColor} fontSize={20} />
            <Typography variant="textBase500" sx={{ color: streakColor }}>
              {i18n("training-plans.drawer.streak", { count: trainingPlanModel.currentStreakCount })}
            </Typography>
          </Stack>
        </StreakBanner>
      )}

      <Stack spacing={1.5}>
        <Typography variant="textBase500" color="text.secondary">
          {i18n("training-plans.drawer.progress.title")}
        </Typography>
        <Stack direction="row" spacing={1}>
          {Array.from({ length: trainingPlanModel.requiredSessionsCount }, (_, index) => (
            <ProgressBarSegment key={`training-plan-progress-${index}`} isCompleted={index < trainingPlanModel.completedSessionsCount} />
          ))}
        </Stack>
      </Stack>

      {trainingPlanModel.isComplete && (
        <PeriodCompleteMessageBox>
          <Typography variant="textLg500" color="dsBase.v200">
            {i18n("training-plans.drawer.progress.complete-message")}
          </Typography>
        </PeriodCompleteMessageBox>
      )}
    </>
  );
};

export default TrainingPlansDrawerProgress;
